var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createAsyncThunk, createAction, } from '@reduxjs/toolkit';
import { classToPlain } from 'class-transformer';
import { GroupingStrategy, NotificationsMapper, NotificationsEventEmitter, } from '../types';
import { Socket } from '../../websocket';
const POLLING_TIMEOUT = 15000;
//eslint-disable-next-line no-magic-numbers
const CHECK_QUEUE_TIMEOUT = POLLING_TIMEOUT + 500;
export const setQueue = createAction('core/notifications/setQueue');
export const addNotificationToQueue = createAction('core/notifications/addNotificationToQueue');
export const addNotificationToList = createAction('core/notifications/addNotificationToList');
export const removeNotification = createAction('core/notifications/removeNotification');
export const resetNotifications = createAction('core/notifications/setNotifications');
export const checkQueue = createAsyncThunk('core/notifications/checkQueue', (_, { dispatch, getState, extra: { inject } }) => {
    const { queue, notifications } = getState().notifications;
    const groupingStrategy = inject(GroupingStrategy);
    const eventEmitter = inject(NotificationsEventEmitter);
    if (!queue.length) {
        return;
    }
    const groupedNotification = groupingStrategy.groupNotifications(queue);
    const mql = window.matchMedia(`(min-width: 1024px)`);
    //eslint-disable-next-line no-magic-numbers
    const maxCount = mql.matches ? 4 : 2;
    const count = maxCount - notifications.length;
    const toAddToList = groupedNotification.slice(0, count);
    toAddToList.forEach((notification) => {
        dispatch(addNotificationToList(notification));
        eventEmitter.onShow(notification);
        setTimeout(() => {
            dispatch(removeNotification(notification.id));
        }, POLLING_TIMEOUT);
        setTimeout(() => {
            dispatch(checkQueue());
        }, CHECK_QUEUE_TIMEOUT);
    });
    dispatch(setQueue(groupedNotification.slice(count)));
});
export const showError = createAsyncThunk('core/notifications/showError', (message_1, _a) => __awaiter(void 0, [message_1, _a], void 0, function* (message, { dispatch }) {
    //eslint-disable-next-line no-magic-numbers
    const id = Math.floor(Math.random() * 5000);
    dispatch(addNotificationToQueue({
        id,
        message,
        type: 'error',
    }));
    dispatch(checkQueue());
}));
export const showNotification = createAsyncThunk('core/notifications/showNotification', (message_1, _a) => __awaiter(void 0, [message_1, _a], void 0, function* (message, { dispatch }) {
    //eslint-disable-next-line no-magic-numbers
    const id = Math.floor(Math.random() * 5000);
    dispatch(addNotificationToQueue({
        id,
        message,
        type: 'info',
    }));
    dispatch(checkQueue());
}));
export const showCustomNotification = createAsyncThunk('core/notifications/showNotification', (data_1, _a) => __awaiter(void 0, [data_1, _a], void 0, function* (data, { dispatch }) {
    data.forEach((item) => {
        //eslint-disable-next-line no-magic-numbers
        const id = Math.floor(Math.random() * 5000);
        dispatch(addNotificationToQueue(Object.assign({ id }, item)));
    });
    dispatch(checkQueue());
}));
export const removeNotificationManually = createAsyncThunk('core/notifications/removeNotificationManually', (id_1, _a) => __awaiter(void 0, [id_1, _a], void 0, function* (id, { dispatch }) {
    dispatch(removeNotification(id));
    dispatch(checkQueue());
}));
export const notificationListener = createAsyncThunk('core/notifications/notificationListener', (payload_1, _a) => __awaiter(void 0, [payload_1, _a], void 0, function* (payload, { rejectWithValue, dispatch, extra: { inject } }) {
    try {
        const notificationsMapper = inject(NotificationsMapper);
        const result = notificationsMapper.mapNotifications([payload]);
        if (result.length) {
            dispatch(showCustomNotification(result));
        }
    }
    catch (err) {
        return rejectWithValue(classToPlain(err));
    }
}));
export const getNotifications = createAsyncThunk('core/notifications/getNotifications', (_1, _a) => __awaiter(void 0, [_1, _a], void 0, function* (_, { rejectWithValue, dispatch, extra: { inject } }) {
    try {
        const socket = inject(Socket);
        socket.on('notification', (payload) => dispatch(notificationListener(payload)));
    }
    catch (err) {
        return rejectWithValue(classToPlain(err));
    }
}));
export const notificationsReducers = (builder) => {
    builder.addCase(setQueue, (state, action) => {
        state.queue = action.payload;
    });
    builder.addCase(addNotificationToQueue, (state, action) => {
        state.queue.push(action.payload);
    });
    builder.addCase(addNotificationToList, (state, action) => {
        state.notifications.push(action.payload);
    });
    builder.addCase(removeNotification, (state, action) => {
        state.notifications = state.notifications.filter(({ id }) => id !== action.payload);
    });
    builder.addCase(resetNotifications, (state) => {
        state.notifications = [];
        state.queue = [];
    });
};
